import { get } from '@classic/Foundation/Services/ApiService'
import { getRacePageDataFromApi as getRaceDataFromApi } from '@core/Areas/Racing/Hooks/useRacePageData/api'
import type {
  RacePageDataTransferObject,
  ResultsPageDataTransferObject,
  StarterDataTransferObject,
} from '@mobi/api-types'

export const getRaceStartersFromApi = ({
  fixtureDate,
  fixtureId,
  raceNumber,
}: {
  fixtureId: string
  fixtureDate: string
  raceNumber: number
}) =>
  get<StarterDataTransferObject[]>({
    url: `/api/meetings/${fixtureId}/${fixtureDate}/race/${raceNumber}/starters`,
  })

export const getRacePageDataFromApi = ({
  fixtureDate,
  fixtureId,
  raceNumbers,
}: {
  fixtureId: string
  fixtureDate: string
  raceNumbers: number[]
}): Promise<RacePageDataTransferObject | ResultsPageDataTransferObject> => {
  if (raceNumbers.length === 1) {
    return getRaceDataFromApi(fixtureId, fixtureDate, raceNumbers[0])
  }

  return get<RacePageDataTransferObject | ResultsPageDataTransferObject>({
    url: `/api/meetings/${fixtureId}/${fixtureDate}/races/${raceNumbers.join(',')}`,
  })
}
